import Enumeration from '@/common/enumeration.js'
import cloneDeep from 'lodash/cloneDeep'
// import isEqual from 'lodash/isEqual'
import i18n from '@/i18n'
import { formatText } from '@/utils/text'

const nullOrUndefine = [null, undefined]
let regBlank = null

/**
 * @author PVThang
 * @param {*} entity đối tượng clone
 * @returns đối tượng clone từ entity
 */
const cloneEntity = (entity) => {
  const type = typeof (entity)
  let result = null

  if (Array.isArray(entity)) {
    result = entity.map(element => {
      return cloneEntity(element)
    })
  } else if (entity != null && type === 'object') {
    result = {}
    Object.keys(entity).forEach(propertyName => {
      result[propertyName] = cloneEntity(entity[propertyName])
    })
  } else {
    result = entity
  }

  return result
}

/**
 * validate câu hỏi được import từ file excel
 * @param {*} questions
 * @returns
 */
const validateQuestionImport = (questions, parentQuestions) => {
  const $t = i18n?.global?.t
  const result = {
    totalQuestion: questions?.length || 0,
    totalSuccess: 0,
    totalFail: 0,
    listStringFail: []
  }

  if (questions.length > 0) {
    questions.map(x => {
      let hasFail = false
      let stringFail = ''

      switch (x.Type) {
        case Enumeration.QuestionType.Select:
        case Enumeration.QuestionType.Yesorno:
        case Enumeration.QuestionType.Fill:
          if (x.Answers.length === 0) {
            stringFail = stringFail.concat($t('Document.MustEnoughAnswer'))
            hasFail = true
          }
          if (x.CorrectAnswers === '') {
            stringFail = stringFail.concat(', ' + $t('Document.LostCorrectAnswer'))
            hasFail = true
          }
          break
        case Enumeration.QuestionType.Group: {
          const countChildQuestion = questions.filter(y => {
            return y?.ParentID === x?.SortOrder
          }).length

          if (countChildQuestion === 0) {
            stringFail = stringFail.concat($t('Document.LostChildQuestion'))
            hasFail = true
          }
          break
        }
        default:
          break
      }
      if (hasFail) {
        result.totalFail++
        result.listStringFail.push({ SortOrder: x.SortOrder, StringFail: stringFail })
      }
    })
  }

  if (parentQuestions.length > 0) {
    parentQuestions.map(x => {
      let hasFail = false
      let stringFail = ''

      const countChildQuestion = questions.filter(y => {
        return y?.ParentID === x?.SortOrder
      }).length

      if (countChildQuestion === 0) {
        stringFail = stringFail.concat($t('Document.LostChildQuestion'))
        hasFail = true
      }

      if (hasFail) {
        result.totalFail++
        result.listStringFail.push({ SortOrder: x.SortOrder, StringFail: stringFail })
      }
    })
  }
  result.totalSuccess = result.totalQuestion - result.totalFail

  return result
}

/**
 * @author PVThang
 * @description so sánh giá trị của dổi tượng
 */
const compareEntity = (newVal, oldVal) => {
  const typeNew = typeof (newVal)
  const typeOld = typeof (oldVal)

  if (newVal === oldVal) {
    return true
  }

  if (typeNew !== typeOld || nullOrUndefine.includes(newVal) || nullOrUndefine.includes(oldVal)) {
    return false
  }

  if (Array.isArray(newVal)) {
    return newVal.length === oldVal.length &&
      newVal.reduce((result, currentVal, index) => {
        return result && compareEntity(currentVal, oldVal[index])
      }, true)
  } else if (typeNew === 'object') {
    return Object.keys(newVal).reduce((result, currentKey) => {
      return result && compareEntity(newVal[currentKey], oldVal[currentKey])
    }, true)
  }

  return false
  // isEqual(newVal, oldVal)
}

/**
 * @description validate nội dung câu hỏi
 * @param {*} question
 * @returns
 */
const validateContentQuestion = (question) => {
  return question?.Content?.trim().length > 0 ||
  question?.Attachments?.length > 0
}

/**
 * @description validate nội dung đáp án
 * @param {*} question
 * @returns
 */
const validateContentAnswer = (question) => {
  if (question.Type !== Enumeration?.QuestionType.Essay) {
    return question.Answers?.every((answer) => {
      return answer?.Content || answer?.Image
    })
  } else {
    return true
  }
}

/**
 * @description validate đáp án đúng sai
 * @param {*} question
 * @returns
 */
const validateCorrectAnswer = (question) => {
  const questionTypes = Enumeration?.QuestionType
  const chooseAnswer = [questionTypes.Select, questionTypes.Yesorno]

  if (chooseAnswer.includes(question.Type)) {
    return question.Answers?.some((answer) => {
      return answer.Correct
    })
  } else {
    return true
  }
}

const validateMappingAnswer = (question) => {
  const questionTypes = Enumeration?.QuestionType
  if (question.Type === questionTypes.Pairing) {
    return !!question.MappingAnswer?.CorrectAnswer?.length
  } else {
    return true
  }
}

const validateExercise = (exercise) => {
  if (exercise.Type === Enumeration.ExerciseType?.Upload) {
    return validateExerciseUpload(exercise)
  }

  return []
}

const validateExerciseUpload = (exercise) => {
  const answerTypes = Enumeration.AnswerType
  const questionType = Enumeration.QuestionType
  const answersFail = []

  switch (exercise?.AnswerType) {
    case answerTypes?.Compose:
      // chưa nhập số câu
      if (!(exercise?.Questions?.length > 0)) {
        return 'Document.ErrorQuestionEmpty'
      }
      // đã nhập số câu
      exercise.Questions.forEach((question, questionIndex) => {
        let isComplete = false

        // Kiểm tra câu trả lời đã được soạn hay chưa
        if (question?.Answers?.length > 0) {
          if (question.Type === questionType.Select) {
            isComplete = question.Answers.some(answer => {
              return answer.Correct
            })
          } else {
            isComplete = question.Answers.every(answer => {
              return answer.Content?.length > 0
            })
          }
        }
        if (!isComplete) {
          answersFail.push(questionIndex + 1)
        }
      })
      break
    case answerTypes?.Upload:
      break
  }
  return answersFail
}

const validateComposeExercise = (exercise) => {
  const $t = i18n?.global?.t
  const questionTypes = Enumeration.QuestionType
  const messageAnswerContent = []
  const messageAnswerCorrect = []
  const messageQuestionContent = []
  const messageParentQuestionContent = []
  const messageMappingAnswer = []
  let message = ''
  let questionIndex = 1

  exercise?.Questions &&
  exercise.Questions?.forEach((question) => {
    // #region validate nội dung câu hỏi

    if (!validateContentQuestion(question) && !question.ParentID) {
      messageQuestionContent.push(`${$t('Assignment.Question')} ${questionIndex}`)
    }

    if (!validateMappingAnswer(question)) {
      messageMappingAnswer.push(`${$t('Assignment.Question')} ${questionIndex}`)
    }

    // #endregion

    if (question.Type !== questionTypes.Essay) {
      if (question?.Answers?.length > 0) {
        // #region validate  nội dung câu trả lời
        if (!validateContentAnswer(question)) {
          messageAnswerContent.push(
                  `${$t('Assignment.Question')} ${questionIndex}`
          )
          // errorQuestions.push(questionIndex)
        }
        // #endregion

        // #region  validate xem có câu trả lời đúng hay chưa
        if (!validateCorrectAnswer(question)) {
          messageAnswerCorrect.push(
                    `${$t('Assignment.Question')} ${questionIndex}`
          )
          // errorQuestions.push(questionIndex)
        }
        // #endregion
      } else {
        // #region  validate có câu trả lời hay không
        messageAnswerCorrect.push(
                `${$t('Assignment.Question')} ${questionIndex}`
        )

        // #endregion
      }
    }
    questionIndex++
  })

  exercise.ParentQuestions &&
  exercise.ParentQuestions.forEach((parentQuestion) => {
    if (!validateContentQuestion(parentQuestion)) {
      let questionIndexs = []
      let title = null
      exercise.Questions?.forEach((question, index) => {
        if (question.ParentID === parentQuestion.SortOrder) {
          questionIndexs.push(index)
        }
      })
      questionIndexs = questionIndexs.sort((a, b) => {
        return a - b
      })

      if (questionIndexs.length) {
        const start = questionIndexs[0] + 1
        const end = questionIndexs[questionIndexs.length - 1] + 1
        let numberQuestion = `${formatText(start, 2, '0')} - ${formatText(end, 2, '0')}`
        if (start === end) {
          numberQuestion = formatText(start, 2, '0')
        }
        title = `${$t('EnumResource.QuestionType.Group')} ${numberQuestion}`
      }

      messageParentQuestionContent.push(title)
    }
  })

  if (messageParentQuestionContent.length) {
    message += $t('NotifyMessage.DidNotFillParentQuestionContentMessage', {
      questions: messageParentQuestionContent.join(', ')
    })
  }

  if (messageAnswerContent.length) {
    message += $t('NotifyMessage.DidNotFillAnswerContentMessage', {
      questions: messageAnswerContent.join(', ')
    })
  }

  if (messageAnswerCorrect.length) {
    message += $t('NotifyMessage.DidNotChoseCorrectAnswerMessage', {
      questions: messageAnswerCorrect.join(', ')
    })
  }

  if (messageQuestionContent.length) {
    message += $t('NotifyMessage.DidNotFillQuestionContentMessage', {
      questions: messageQuestionContent.join(', ')
    })
  }

  if (messageMappingAnswer.length) {
    message += $t('NotifyMessage.DidNotMappingAnswer', {
      questions: messageMappingAnswer.join(', ')
    })
  }

  return message
}
/**
 * @description Convert exercise thành cấu trúc phục vụ show câu hỏi nhóm
 * @author NTQuy
 * @param {*} exercise
 * @returns
 */
const convertExercise = (exercise) => {
  if (!exercise) return
  let questions = cloneDeep(exercise.Questions)
  const normalQuestion = questions?.filter(question => !question.ParentID)
  normalQuestion?.forEach((question) => {
    question.Label = question?.SortOrder
  })
  exercise.ParentQuestions?.forEach((parentQuestion, index) => {
    const firstChildrenQuestionIndex = questions?.findIndex(question => !!(question.ParentID === parentQuestion.SortOrder))
    // const firstChildrenQuestion = questions?.find((question) => !!(question.ParentID === parentQuestion.SortOrder))
    const childrenQuestions = questions?.filter(question => question?.ParentID === parentQuestion?.SortOrder)
    if (childrenQuestions.length > 0) {
      childrenQuestions?.forEach((question) => {
        question.Label = question?.SortOrder
      })
      const questionCustom = {
        Type: Enumeration.QuestionType.Group,
        ChildrenQuestions: childrenQuestions,
        ParentQuestion: parentQuestion,
        SortOrder: childrenQuestions.map(childrenQuestion => childrenQuestion.SortOrder),
        Label: `${childrenQuestions[0]?.SortOrder} - ${childrenQuestions[childrenQuestions.length - 1]?.SortOrder}`
      }

      normalQuestion?.splice(firstChildrenQuestionIndex, 0, questionCustom)

      questions = questions.filter(question => question.ParentID !== parentQuestion?.SortOrder)
      questions.splice(firstChildrenQuestionIndex, 0, questionCustom)
    }
  })

  return normalQuestion
}

/**
 * @description Convert field MappingAnswer thành string trước khi cất xuống
 * @author NTQuy
 */
const handleMappingAnswer = (exerciseStore, type) => {
  const exercise = cloneDeep(exerciseStore)
  exercise?.Questions?.map(question => {
    if (type === Enumeration.HandlePairingAnswerType.Convert) {
      if (question.MappingAnswer?.length >= 0) {
        question.MappingAnswer = JSON.stringify(question.MappingAnswer)
      } else {
        if (question.MappingAnswer?.CorrectAnswer?.length) {
          question.MappingAnswer.CorrectAnswer = JSON.stringify(question.MappingAnswer.CorrectAnswer)

          question.MappingAnswer.AnswerColumnName = JSON.stringify(question.MappingAnswer.AnswerColumnName)
        } else {
          question.MappingAnswer = null
        }
      }
    } else {
      if (typeof (question?.MappingAnswer) === 'string') {
        question.MappingAnswer?.length
          ? question.MappingAnswer = JSON.parse(question.MappingAnswer)
          : question.MappingAnswer = []
      } else {
        if (!question.MappingAnswer) {
          question.MappingAnswer = {
            CorrectAnswer: [],
            AnswerColumnName: []
          }
        }

        if (question.MappingAnswer?.CorrectAnswer?.length) {
          question.MappingAnswer.CorrectAnswer = JSON.parse(question.MappingAnswer?.CorrectAnswer)
          if (typeof (question.MappingAnswer.CorrectAnswer) === 'object') {
            question.MappingAnswer.CorrectAnswer = question.MappingAnswer?.CorrectAnswer?.map((answer) => {
              answer = answer.sort((a, b) => a - b)
              return answer
            }).sort()
          }
        }

        if (question.MappingAnswer?.AnswerColumnName?.length) {
          question.MappingAnswer.AnswerColumnName = JSON.parse(question.MappingAnswer?.AnswerColumnName)
        }

        question.Answers?.map(answer => {
          answer.SortOrder > 1000 ? answer.Column = Enumeration.PairingAnswerCol.SECONDS_COL : answer.Column = Enumeration.PairingAnswerCol.FIRST_COL
          return answer
        })
      }
      if (question.MappingStudentAnswer) {
        question.MappingStudentAnswer = JSON.parse(question.MappingStudentAnswer)

        question.MappingStudentAnswer = question?.MappingStudentAnswer?.map(answer => {
          answer = answer.sort((a, b) => a - b)
          return answer
        }).sort()
      }
    }

    return question
  })

  return exercise
}

/**
 * @description Convert field MappingAnswer thành string trước khi cất xuống (1 câu hỏi)
 * @author lhlong
 */
const handleSaveMappingAnswerOneQuestion = (question) => {
  const mappingQuestion = cloneDeep(question)
  if (mappingQuestion.MappingAnswer?.length >= 0) {
    mappingQuestion.MappingAnswer = JSON.stringify(mappingQuestion.MappingAnswer)
  } else {
    if (mappingQuestion.MappingAnswer?.CorrectAnswer) {
      mappingQuestion.MappingAnswer.CorrectAnswer = JSON.stringify(mappingQuestion.MappingAnswer.CorrectAnswer)

      mappingQuestion.MappingAnswer.AnswerColumnName = JSON.stringify(mappingQuestion.MappingAnswer.AnswerColumnName)
    }
  }

  return mappingQuestion
}

/**
 * @description Xóa câu hỏi cha thừa nếu không có câu hỏi con nào
 * @author NTQuy
 */
const removeRedundantParentQuestion = (exerciseStore) => {
  const parentQuestions = exerciseStore.ParentQuestions?.filter(parentQuestion => {
    const NOT_FOUND_CHILDREN_QUESTION = -1
    const checkChildrenQuestion = exerciseStore.Questions?.findIndex(question => question.ParentID === parentQuestion.SortOrder)

    if (checkChildrenQuestion === NOT_FOUND_CHILDREN_QUESTION) {
      return false
    }
    return true
  })

  return parentQuestions
}

/**
 * @description Xử lý nội dung câu hỏi
 * @author NTQuy
 */
const handleContentQuestion = (exerciseStore) => {
  const exerciseStoreClone = { ...exerciseStore }
  exerciseStoreClone.Questions?.map(question => {
    question.Content = trimSpaceContentQuestion(question.Content)
    return question
  })

 exerciseStoreClone.ParentQuestions?.map(parentQuestion => {
   parentQuestion.Content = trimSpaceContentQuestion(parentQuestion.Content)
   return parentQuestion
 })

 return exerciseStoreClone
}

/**
 * @description cắt bỏ khoảng trống khi ấn enter ở cuối câu
 * @author NTQuy
 */
const trimSpaceContentQuestion = (value) => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(value, 'text/html')
  const content = doc.body.lastElementChild?.innerHTML

  if (content) {
    if (!content.replace(/&nbsp;/g, '')?.length) {
      doc.body.lastElementChild.remove()
      return trimSpaceContentQuestion(doc.body.outerHTML)
    } else {
      return doc.body.outerHTML
    }
  } else {
    return value
  }
}

/**
 * @description Xử lý trước khi cất dữ liệu
 * @author NTQuy
 */
const handleBeforeSave = (exerciseStore) => {
  let exercise = cloneDeep(exerciseStore)

  let exerciseFormat = handleMappingAnswer(exercise, Enumeration.HandlePairingAnswerType.Convert)
  exerciseFormat = handleContentQuestion(exerciseFormat)
  exerciseFormat.ParentQuestions = removeRedundantParentQuestion(exerciseFormat)

  exercise = exerciseFormat

  exercise.QtyQuestion = exercise.Questions?.length

  return exercise
}

/**
 * @author PVThang
 * @description Lấy chuỗi regex
 */
const getRegexBlankString = () => {
  const values = ['[ ]{3,}', '[.]{3,}', '[_]{3,}', '[…]{1,}']

  return `${values[0]}${values[1]}${values[2]}|${values[0]}${values[2]}${values[1]}|${values[1]}${values[0]}${values[2]}|${values[1]}${values[2]}${values[0]}|${values[2]}${values[1]}${values[0]}|${values[2]}${values[0]}${values[1]}|${values[0]}${values[1]}|${values[0]}${values[2]}|${values[1]}${values[2]}|${values[1]}${values[0]}|${values[2]}${values[1]}|${values[2]}${values[0]}|${values[0]}|${values[1]}|${values[2]}|${values[3]}`
}

/**
 * @author PVThang
 * @description Lấy số lượng chỗ trống trong 1 chuỗi
 */
const getNumberBlank = (content) => {
  content = (content || '').replace(/&nbsp;/g, ' ')
  if (!regBlank) {
    const strReg = getRegexBlankString()
    regBlank = new RegExp(strReg, 'g')
  }
  const numberBlank = (content?.match(regBlank) || []).length

  return numberBlank
}

/**
 * @description tự động xóa đáp án câu hỏi dạng chọn đáp án
 * @author NTQuy
 * @param {*} question
 * @returns
 */
const autoRemoveSelectAnswer = (question) => {
  if (question.Type !== Enumeration.QuestionType.Select) return []

  const answers = question.Answers
  const answerRemove = []
  const answerKeep = []

  if (answers.every((answer) => !answer.Correct)) return answerRemove
  if (answers.every((answer) => !answer.Content?.length)) return answerRemove

  for (let index = 0; index < answers.length; index++) {
    const answer = answers[index]

    !answer.Content.length && !answer.Correct
      ? answerRemove.push(index)
      : answerKeep.push(index)
  }

  if (answerKeep.length) {
    if (answerKeep.some(answerIndex => !answers[answerIndex].Content?.length)) return []
  }

  return answerRemove
}
/**
 * set pause audio là mảng
 * @param {*} refAudio
 * TTLONG
 */
const setAudioPauseIsArray = (refAudio) => {
  refAudio[0].pause()
}
/**
 * set play audio là mảng
 * @param {*} refAudio
 * TTLONG
 */
const setAudioPlayIsArray = (refAudio) => {
  refAudio[0].play()
}
export {
  validateContentQuestion,
  validateContentAnswer,
  validateCorrectAnswer,
  validateMappingAnswer,
  cloneEntity,
  compareEntity,
  validateExercise,
  convertExercise,
  validateComposeExercise,
  getNumberBlank,
  validateQuestionImport,
  autoRemoveSelectAnswer,
  handleMappingAnswer,
  removeRedundantParentQuestion,
  handleContentQuestion,
  handleBeforeSave,
  handleSaveMappingAnswerOneQuestion,
  setAudioPauseIsArray,
  setAudioPlayIsArray
}
